import '../assets/css/HeroSection.css'
import '../assets/css/AboutSection.css'
import HeroSection from './HeroSection.js'
import AboutSection from './AboutSection.js'
import SkillsetSection from './SkillsetSection.js'
import ProjectSection from './ProjectSection.js'
import ChallengeSection from './ChallengeSection.js'
import FoooterTiles from './FooterSection'
// import { fadeIn } from 'react-animations'
// import { bounceIn } from 'react-animations'
import Fade from 'react-reveal/Fade';

function Home() {
  return (
    <div className="Hero">
      <Fade left>
          <section className="Hero-bg">
            <HeroSection />   
          </section>
      </Fade>
      <Fade right>
        <section className="about">
          <AboutSection />
        </section>
      </Fade>
      <Fade left>
        <section className="skillset">
          <SkillsetSection />
        </section>
      </Fade>
      <Fade right>
        <section>
          <ProjectSection />
        </section>
      </Fade>
      <Fade left>
        <section>
          <ChallengeSection />
        </section>
      </Fade>
      <Fade left>
      <section>
        <FoooterTiles />
      </section>
      </Fade>
    </div>
  );
}

export default Home;
